import React from "react";
import PropTypes from "prop-types";
import AriaModal from "react-aria-modal";

const Modal = ({ title, onExit, children, dialogClass }) => (
  <AriaModal dialogClass={dialogClass} titleText={title} focusDialog mounted={true} onExit={onExit}>
    {/* Note: markup was ported from legacy jquery teladoc modal and thus uses table for layout, should convert to CSS layout */}
    <table className="modal_bg react_modal">
      <tbody>
        <tr>
          <td className="modal_wp">
            <div className="modal_ct" style={{ display: "inline-block" }}>
              <div id="popup_wrapper" className="modal">
                <div className="modal_title_bar">
                  <span className="modal_title">{title}</span>
                  <a
                    href="javascript:void(0)"
                    className="modal_close"
                    aria-label="Close Dialog"
                    role="button"
                    id="modal_close_check_box"
                    onClick={onExit}
                  ></a>
                </div>
                <div className="modal_body">{children}</div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </AriaModal>
);

Modal.propTypes = {
  title: PropTypes.string.isRequired,
  onExit: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  dialogClass: PropTypes.string
};

export { Modal };
